import axios from 'axios';
import qs from 'qs';
import {DISMISS_NOTIFICATION} from './store/mutation-types';

export function httpBuilder(config) {
  let renewTokenPromise;

  const http = axios.create({
    baseURL: config.baseUrl,
    // let parameter lists have the format ?param=x&param=y instead of ?param[]=x
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'}),
  });

  http.enableInterceptors = function (router, auth, store) {
    // generic handling of JWT expired errors
    http.interceptors.response.use(undefined, async error => {
      if (error.response && error.response.status === 401 && !error.request.responseURL.endsWith('/token')) {
        // TODO: replace check with custom error code
        if (error.response.data.errorCode === 'TOKEN_EXPIRED') {
          console.debug('Token expired');
          if (!renewTokenPromise) {
            renewTokenPromise = store.dispatch('renewToken');
          }
          const status = await renewTokenPromise;
          renewTokenPromise = undefined;
          if (status) {
            store.commit(DISMISS_NOTIFICATION);
            error.config.headers['Authorization'] = `Bearer ${store.state.auth.token}`;
            return http.request(error.config);
          }
        }
        auth.logout(router);
      } else if (error.response) {
        console.error('Error accessing API: ' + error.message);
      }
      return Promise.reject(error);
    });
    // check URL length before sending a request
    http.interceptors.request.use(config => {
      if (config.url.length > 8000) {
        const msg = 'The URL exceeds the maximum length of 8000 characters';
        alert(msg);
        throw new Error(msg);
      }
      return config;
    }, error => {
      throw error;
    });
  };

  return http;
}
